import PanelSedeComponent from '../components/PanelSede/PanelSede';

export default function PanelSede() {
    return (
        <div>
            <PanelSedeComponent/>
        </div>
    )
}